import _ from 'lodash'
import { useContext, useState } from 'react'

import { ITERATEE } from 'components/TransferList'
import { AddEditPageContext } from 'features/inventory/page/contexts/AddEditPageContext'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { AdUnitForPageTransferList } from './adUnitForPageTransferList'
import { adUnitForPageTransferListFromDTO } from './api/mapper'
import { GET_AD_UNITS_FOR_PAGE_TRANSFER_LIST } from './api/query'
import { AdUnitForPageTransferListDTO, Data, Variables } from './api/types'
import { UseGetAdUnitsForPageTransferList, UseGetAdUnitsForPageTransferListProps } from './types'
import { sorted } from './utils'

export const useGetAdUnitsForPageTransferList = ({
  domainId,
}: UseGetAdUnitsForPageTransferListProps): UseGetAdUnitsForPageTransferList => {
  const { page } = useContext(AddEditPageContext)
  const [all, setAll] = useState<AdUnitForPageTransferList[]>([])

  const active: AdUnitForPageTransferList[] = page?.adUnits ?? []

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async data => {
      const {
        node: { adUnits },
      } = data

      setAll(
        sorted(
          adUnits.map(
            (adUnit: AdUnitForPageTransferListDTO): AdUnitForPageTransferList =>
              adUnitForPageTransferListFromDTO(adUnit),
          ),
        ),
      )
    },
    options: {
      enabled: !!domainId,
    },
    query: GET_AD_UNITS_FOR_PAGE_TRANSFER_LIST,
    variables: { domainId },
  })

  return {
    active,
    all,
    available: _.differenceBy(all, active, ITERATEE),
    loading,
  }
}
